export enum CountryCode {
    south_africa = 'za',
    zimbabwe = 'zw',
}
